<div class="modal-header">
  <h3>Produktionsschritt editieren - Artikel Felder</h3>
</div>

<div class="modal-body">
  <div class="row">

    <div class="col-lg-3 article-production-max-height">

      <!-- Draggable -->
      <div class="row">
        @for (step of articleSpecification; track step; let i = $index) {
          <div class="col-md-6" dnd-draggable
            [dropZones]="zones" [dragData]="{data: step, typ: 'article'}">
            <div class="panel panel-default dnd-drag-item">
              @if (step.production_description !== step.production_title) {
                ({{ step.production_description }}):&nbsp;
              }
              {{ step.production_title }}
            </div>
          </div>
        }
      </div>

    </div>

    <div class="col-lg-6">

      <div class="panel panel-default">
        <div class="panel-body">

          @for (stepLine of lines; track stepLine; let lineIndex = $index) {
            <div>
              <div class="row">
                @for (step of stepLine.inner; track step; let stepIndex = $index) {
                  <div class="col-md-3">
                    @if (canDrop(lineIndex, stepIndex)) {
                      <div class="panel panel-default panel-min-height dnd-drag-item"
                        dnd-droppable
                        [dropZones]="[step.zone]"
                        (dropSuccessEmitter)="add($event, lineIndex, stepIndex)">
                        <div class="row">
                          <div class="col-md-9">
                            @if (step.step?.article) {
                              @if (step.step.article.production_description !== step.step.article.production_title) {
                                ({{ step.step.article.production_description }})
                              }
                              {{ step.step.article.production_title }}
                            }
                            @if (step.step?.validation) {
                              @if ($safeNavigationMigration(step.step?.validation.group_label) !== null && step.step?.validation.group_label !== '') {
                                [{{ step.step?.validation.group_label }}]&nbsp;
                              }
                              {{ step.step?.validation.label }}
                            }
                            @if (!step.step) {
                              <strong>Neues Element hier einfügen</strong>
                            }
                          </div>
                          <div class="col-md-3">
                            @if (canEdit(lineIndex, stepIndex)) {
                              <button class="btn btn-link" (click)="edit(step.step)">
                                <i class="fa fa-edit"></i>
                              </button>
                            }
                            @if (canRemove(lineIndex, stepIndex)) {
                              <button class="btn btn-link" (click)="remove(lineIndex, stepIndex)">
                                <i class="fa fa-remove red_alert"></i>
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (stepLine.empty) {
                  <div class="col-md-9">
                    <div class="panel panel-default panel-min-height dnd-drag-item">
                      <div class="row">
                        <div class="col-md-11">
                          <strong>Leerzeile</strong>
                        </div>
                        <div class="col-md-1">
                          <!-- FIXME: correct ngIf -->
                          @if (canRemove(lineIndex, null)) {
                            <button class="btn btn-link" (click)="remove(lineIndex, null)">
                              <i class="fa fa-remove red_alert"></i>
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="col-md-1">
                  @if ((lines.length - 2) !== lineIndex && (lines.length - 1) !== lineIndex) {
                    <button class="btn btn-link" (click)="down(lineIndex)"
                      >
                      <i class="fa fa-chevron-down"></i>
                    </button>
                  }
                </div>
                <div class="col-md-1">
                  @if (lineIndex !== 0 && (lines.length - 1) !== lineIndex) {
                    <button class="btn btn-link" (click)="up(lineIndex)"
                      >
                      <i class="fa fa-chevron-up"></i>
                    </button>
                  }
                </div>
                <div class="col-md-1">
                  @if (!stepLine.empty) {
                    @if ((lines.length - 1) !== lineIndex) {
                      <button class="btn-btn-link" (click)="newLine(lineIndex)">
                        <i class="fa fa-plus"></i>
                      </button>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>

      </div>

    </div>

    <div class="col-lg-3 article-production-max-height">
      <div class="row">
        @for (validation of articleExtraValidation; track validation; let i = $index) {
          <div class="col-md-6" dnd-draggable
            [dropZones]="zones" [dragData]="{data: validation, typ: 'delivery'}">
            <div class="panel panel-default dnd-drag-item">
              @if (validation.group_label !== '') {
                [{{ validation.group_label }}]&nbsp;
              }
              {{ validation.label }}
            </div>
          </div>
        }
      </div>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-success pull-right" (click)="save()">
    Speichern
  </button>
</div>
